export type MobileAppAction = 'login' | 'logout' | 'openSettings' | 'openInfo';

// biome-ignore lint/style/noVar: <explanation>
declare var window: Window;

type WebViewWindow = Window & {
  ReactNativeWebView: { postMessage: (data: unknown) => void };
};

export type MobileActionMap = {
  login: { token: string };
  logout: undefined;
  openSettings: { tab?: 'account' };
  openInfo: undefined;
};

export type ActionPayload<T extends MobileAppAction> = MobileActionMap[T];

export function invokeMobileAppAction<T extends MobileAppAction>(
  action: T,
  data: ActionPayload<T>
) {
  const message = JSON.stringify({ action, data });

  if (
    //@ts-ignore
    typeof window !== 'undefined' &&
    //@ts-ignore
    'ReactNativeWebView' in window &&
    //@ts-ignore
    typeof (window as WebViewWindow).ReactNativeWebView.postMessage ===
      'function'
  ) {
    //@ts-ignore
    (window as WebViewWindow).ReactNativeWebView.postMessage(message);
  } else {
    console.warn('ReactNativeWebView is not available');
  }
}
